var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2.931c-.495 0-.936.207-1.269.531A1.78 1.78 0 00.4 2.731c0 .495.207.936.531 1.269L4 7.069 7.069 4A1.78 1.78 0 007.6 2.731c0-.495-.207-.936-.531-1.269A1.78 1.78 0 005.8.931c-.495 0-.936.207-1.269.531A1.78 1.78 0 004 2.731c0-.495-.207-.936-.531-1.269A1.78 1.78 0 002.2.931z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.12bec8da51198c27776289893d35400c.svg";
export { ForwardRef as ReactComponent };